import "./ArchiveProductTemplate.module.css"
import Header from "@/reusable_sections/Header"
import ArchiveTitleSectionSection from "./sections/ArchiveTitleSectionSection"
import ShopContent from "./sections/ShopContent"
import MainFooter from "@/reusable_sections/Footer"

export default function ArchiveProductTemplatePage() {

  return (
    <div>
      <Header />
      <ArchiveTitleSectionSection />
      <ShopContent />
      <MainFooter />
    </div>
  )
}
